import React from 'react';
import { Box, Carousel, ShimmerBox } from '@common-fe/common-fe';

import { WarnModal } from '@/components/elements';
import RenewalSetupModal from '@/modules/Renewals/RenewalSetup/RenewalSetupModal/RenewalSetupModal.tsx';

import { useBannersList } from './hooks';

export const BannersShimmerBox = () => (
  <Box>
    <Box margin={{ top: 'spacing24' }}>
      <ShimmerBox height="28px" width="98px" round="button2Round" />
      <ShimmerBox height="278px" margin={{ top: 'spacing16' }} round="moduleRound" />
    </Box>
    <Box margin={{ top: 'spacing24' }}>
      <ShimmerBox height="28px" width="71px" round="button2Round" />
      <ShimmerBox height="278px" margin={{ top: 'spacing16' }} round="moduleRound" />
    </Box>
  </Box>
);

const Banners = () => {
  const {
    banners,
    renewalData,
    errorModal,
    isRenewDetailsModalVisible,
    setErrorModal,
    errorPlanYearId,
    handleCompleteRenewal,
    handleSetVisibleRenewalPopup,
  } = useBannersList();

  if (!banners.length) {
    return null;
  }
  return (
    <>
      <Box data-testid="banners">
        <Carousel width="100%" slides={banners} />
      </Box>
      <WarnModal
        testId="renewal-wizard-error-modal"
        visible={errorModal}
        onSetVisible={setErrorModal}
        header="The server encountered an error processing the request"
        helptext="It doesn't appear to have affected your data, but we cannot renew your plan with the latest records. Our technical staff have been automatically notified and will be looking into this with the utmost urgency."
        buttonText="Close"
        onSubmit={async () => {
          setErrorModal(false);
          if (errorPlanYearId) {
            await handleCompleteRenewal(errorPlanYearId, true);
          }
        }}
        submitButtonText="Try again"
      />
      <RenewalSetupModal
        isVisible={isRenewDetailsModalVisible}
        isViewMode
        showPlansButton
        renewalSetupData={renewalData}
        onSetVisible={handleSetVisibleRenewalPopup}
      />
    </>
  );
};

export default Banners;
